export const FETCH_LEAVE_ALLOCATION_REQUEST = "FETCH_LEAVE_ALLOCATION_REQUEST";
export const FETCH_LEAVE_ALLOCATION_SUCCESS = "FETCH_LEAVE_ALLOCATION_SUCCESS";
export const FETCH_LEAVE_ALLOCATION_FAIL = "FETCH_LEAVE_ALLOCATION_FAIL";

export const CLEAR_LEAVE_ALLOCATION = "CLEAR_LEAVE_ALLOCATION";

export const FETCH_LEAVE_SUMMARY_REQUEST = "FETCH_LEAVE_SUMMARY_REQUEST";
export const FETCH_LEAVE_SUMMARY_SUCCESS = "FETCH_LEAVE_SUMMARY_SUCCESS";
export const FETCH_LEAVE_SUMMARY_FAIL = "FETCH_LEAVE_SUMMARY_FAIL";